import { BodyPartName, BodyPartGroupName } from "../body-parts";
import { ModelConfigParams, genericEnd, genericStartQC } from "./model-config-params";

const colonMiddleChecklist = [
  "Stomach and pancreas - have been identified and labelled correctly",
  "Colon - has been identified and correctly labelled, all parts are connected and do not include a small bowel",
  "Arteries - all have been identified, correctly labelled and conform to the standard classification",
  "Veins - all have been identified, correctly labelled and conform to the standard classification",
  "Lesion (tumour) - has been identified and correctly labelled according the information received in the case notes",
  "Lymph nodes - all visible lymph nodes in the area for resection (according to the case notes) have been identified and correctly labelled",
]

const SHARED_BODY_PARTS: (BodyPartName | BodyPartGroupName)[] = [
  'tumourWithLesionUncertain',
  'arteryWithDetailAndUncertainAndParts',
  'veinWithDetailAndUncertainAndParts',
  'stomach',
  'pancreas',
  'colon',
  'kidney',
  'spleen',
  'gallBladder',
  'bileDuct',
  'bladder',
  'collectingColorectal',
  'liver',
  'uterus',
  'bone',
  'stent',
  'unknown',
  'calcification',
  'lymph',
  'portalVein',
  'fistula',
  'nerveColorectal',
  'mesorectum',
  'rectum',
  'pelvicBones',
  'ovary',
  'prostate',
  'seminalVesicle',
  'sphincter',
  'vagina',
]

export const colorectal: ModelConfigParams = {
  bodyParts: [
    ...SHARED_BODY_PARTS,
    'psoas',
    'abdo',
  ],
  checklist: [
    "Check Colon",
    "Check Stomach",
    "Check Pancreas",
    "Check Aorta",
    "Check SMA",
    "Check Middle colic artery",
    "Check Right colic artery",
    "Check Ileocolic artery",
    "Check Gastroduodenal artery",
    "Check Portal vein",
    "Check SMV",
    "Check Middle colic vein ",
    "Check Right colic vein",
    "Check Ileocolic vein",
    "Check Henle’s trunk"
  ],
  checklistQC: [
    genericStartQC,
    colonMiddleChecklist,
    genericEnd,
  ].flat(),
  tissueHotkeys: {
    tumour: 'q',
    artery: 'w',
    vein: 'e',
    portalVein: 'r',
    arteryUncertain: "t",
    lymph: "u",
    veinUncertain: "y",
    colon: "i",
    stomach: "o",
    pancreas: "p",
    aorta: "alt + q",
  },
  defaultIntensityRange: [-200, 400],
}

export const pelvis: ModelConfigParams = {
  bodyParts: [
    ...SHARED_BODY_PARTS,
    'muscleLeftRight',
    'slam',
  ],
  checklist: ["Checked anatomy ?"],
  checklistQC: ["Label 1 done ?", "Label 2 done ?", "Label 3 done ?"],
  defaultIntensityRange: [0, 2000],
  internal: true,
}
